export default __webpack_public_path__ + "static/media/480_dummy2016-kunstshop01-de.19d4374c.png";